import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { commonTurnActions } from 'src/app/store/common/turn/turn.action';
import { environment } from 'src/environments/environment';
import { VITAL_SIGN } from './general-vital-sign.constants';
import { GeneralHeaderModel } from 'src/app/model/general/header';

@Injectable({
  providedIn: 'root'
})
export class GeneralVitalSignService extends BaseService {

  readonly screen = VITAL_SIGN;

  constructor(
    protected store: Store<any>,
    protected rest: RestService,
    protected messageService: VonMessageService,
    protected dialogService: DialogService
  ) {
    super();
  }

  getHeader = (turn: number): Observable<GeneralHeaderModel> =>
    this.rest.get<GeneralHeaderModel>({ url: `${environment.endpoints.general}/header/{turn}`, urlParams: { turn }}).pipe(
      map(header => header ? header : { turn } as GeneralHeaderModel)
    )

  save = (header: GeneralHeaderModel): Observable<any> =>
    this.rest.post<void>({ url: `${environment.endpoints.general}/header`, body: header })
      .pipe(
        tap(() => {
          this.store.dispatch(commonTurnActions.deleteResultAction({ turn: header.turn! }));
          this.messageService.addSuccess(this.screen.saveSuccess);
        })
      )

}
